import { render } from "./thumbsup-svg.vue?vue&type=template&id=2c366d3c"
const script = {}

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__